<template>
	<div class="ui center aligned middle aligned no-data-available" :style="{ height: `${height}px` }">
		<div class="ui icon small header">
			<i class="bar chart icon"></i> {{ i18n('Error.DataUnavailable').toUpperCase() }}
		</div>
	</div>
</template>

<script>
  import {i18nMixin} from '@/modules/neodash/mixins';

  export default {
    props: {
      height: {
        type: Number,
        required: true
      }
    },

    mixins: [i18nMixin]
  };
</script>

<style lang="scss" scoped>
	.no-data-available {
		display: flex;
		align-items: center;
		justify-content: center;

		.ui.header {
			color: #212121;

			.icon {
				color: #bdbdbd;
			}
		}
	}
</style>
